import Modal from '@/components/common/modal.vue';
import ModalOptions from '@/interfaces/modal-options';
import ModalRef from '@/models/modal-ref';
import { SweetModal } from 'sweet-modal-vue';
import { Component } from 'vue';
import { Vue } from 'vue-property-decorator';
import { CombinedVueInstance } from 'vue/types/vue';

// tslint:disable-next-line:max-line-length
type ComponentInstance = CombinedVueInstance<Record<never, any> & Vue, object, object, object, Record<never, any>>;
class ModalService {
  private openedModal: ModalRef[] = [];
  private container!: Element;
  private vueInstanceOptions: any = {};

  open<T>(modal: Component, options: ModalOptions<T> = {}): ModalRef {
    if (!this.container) {
      throw Error();
    }

    this.closeBeforeOpenNew();

    const modalInstance = this.mountModalComponent(options) as SweetModal;
    const contentInstance = this.mountModalContentComponent(modal, options);

    modalInstance.$el.querySelector('.sweet-content')!.appendChild(contentInstance.$el);
    this.container.appendChild(modalInstance.$el);
    const ref = modalInstance.$refs.modal as SweetModal;
    ref.$once('close', () => this.close(modalInstance));
    ref.open();
    contentInstance.$once('close', () => ref.close());
    const modalRef = new ModalRef(modalInstance);
    this.openedModal.push(modalRef);
    return modalRef;
  }

  closeBeforeOpenNew() {
    if (this.openedModal.length) {
      this.closeAll();
    }
  }

  closeAll() {
    this.openedModal.forEach((x) => x.close());
  }

  setContainer(container: Element, options: any) {
    this.container = container;
    this.vueInstanceOptions = options;
  }

  get hasOpened(): boolean {
    return !!this.openedModal.length;
  }

  private close(instance: ComponentInstance) {
    this.container.removeChild(instance.$el);
    this.openedModal.filter((x) => x !== instance);
  }

  private mountModalComponent<T>(options: ModalOptions<T>): ComponentInstance {
    const ModalComponent = Vue.extend(Modal);
    const modalInstance = new ModalComponent();
    (modalInstance as any).setOverlayTheme(options.overlayTheme);
    (modalInstance as any).setWidth(options.width);
    (modalInstance as any).setOverlayCanceling(options.overlayCanceling);
    (modalInstance as any).setHideCloseButton(options.hideCloseButton);
    modalInstance.$mount();

    return modalInstance;
  }

  private mountModalContentComponent<T>(modal: Component, options: ModalOptions<T>): ComponentInstance {
    const ModalContentComponent = Vue.extend(modal as any);
    const contentInstance = new ModalContentComponent(this.vueInstanceOptions);
    contentInstance.$mount();
    (contentInstance as any).data = options.data || {};

    return contentInstance;
  }
}

const service = new ModalService();

export default service;
